/**
 * Krok REPORT1B — JEDEN ZDROJ VELIKOSTI PISMA PRO SAZBU REPORTU V5.
 *
 * Do REPORT1B mel kazdy rez svou velikost zapsanou DVAKRAT: jednou jako
 * literal v CSS retezci (`css.ts`), podruhe jako cislo v JS vypoctu
 * (`estimate.ts`), ktery bez prohlizece pocita, kolik mm blok zabere
 * (ROZHODNUTI BRAND2-SAZBA-REPORTU). Nic nehlidalo, ze se oba literaly
 * shoduji — zmena jednoho bez druheho by tise rozladila sazbu (stranka by
 * bud zbytecne prazdna, nebo by `.page{overflow:hidden}` orizl text).
 *
 * Tenhle modul je TA JEDNA SKALA: kazda velikost pisma, kterou report v5
 * pouziva, ma tu jmeno a hodnotu. `css.ts` i `estimate.ts` z nej cist,
 * zadny z nich uz cislo nezapise podruhe.
 *
 * MANUAL ZNACKY „NAVES" (`docs/design/brand-naves/`, str. 5, R.B. 19. 10. 2026):
 * „V PDF reportu: text 11–12 pt, nadpis 24–28 pt." Zmenily se proto jen TRI
 * hodnoty (`body`, `h1`, `h2`) — viz ROZHODNUTI REPORT1B-SKALA v reportu kroku.
 * Ostatni rezy (popisky, tabulky, paticka, stitky…) nejsou „text" ani „nadpis"
 * v tomto smyslu a manual pro ne vlastni cislo nedava — zustavaji proto na
 * puvodni hodnote z prototypu REP1–REPB2.
 */
/** Jmeno kazdeho rezu odpovida CSS selektoru, kde se pouziva (viz komentar u hodnoty). */
export const PT = {
    /** `body` — bezny odstavec. MANUAL: text 11–12 pt (bylo 9.8). */
    body: 11.5,
    /** `.small`, `.steps em` (stejna hodnota, dva ruzne selektory). */
    small: 8.2,
    /** `h1` — titulni nadpis titulky. MANUAL: nadpis 24–28 pt (bylo 25). */
    h1: 28,
    /** `h2` — nadpis kapitoly. MANUAL: nadpis 24–28 pt (bylo 18). */
    h2: 24,
    /** `h3` — podnadpis v kapitole (manualem neresena uroven, zustava). */
    h3: 10.4,
    /** `h4`, nezaklenuty text otazky mimo predlohu bytu. */
    h4: 10,
    /** `.run`, zahlavi stranky — maly popisek. */
    runLabel: 8,
    /** `.rn` — kod kapitoly v zahlavi podrobneho dokumentu. */
    runCode: 11,
    /** `.rt` — nazev kapitoly v zahlavi (mimo predlohu bytu). */
    runTitle: 8.6,
    /** `.run .rt` v predloze bytu (vetsi, serifovy nazev sekce). */
    runTitleFlat: 15,
    /** `.fol` — paticka kazde stranky. */
    footer: 7.4,
    /** `.cno` — typ dokumentu v brandbaru titulky. */
    coverLabel: 8.6,
    /** `.bm` — iniciály kancelare bez loga. */
    markInitials: 9,
    /** `.kicker` — radek nad titulkem titulky. */
    kicker: 9.5,
    /** `.lede` — uvodni odstavec titulky. */
    lede: 11.2,
    /** `.decide span`, `.kpis span`, `.tile>span` — maly popisek hodnoty. */
    labelSmall: 7.8,
    /** `.decide b` — hodnota rozhodovaci dlazdice na titulce. */
    decideValue: 11.5,
    /** `.decide b` v predloze bytu. */
    decideValueFlat: 12,
    /** `.idline` — radek identifikatoru na titulce. */
    idline: 8,
    /** `.verdict p` — text verdiktu. */
    verdictText: 10.4,
    /** `.og` — nazev skupiny v otisku kontrol. */
    imprintGroup: 8.6,
    /** `.cell` — jednotliva kontrola v otisku. */
    imprintItem: 8,
    /** `.t` — zakladni velikost bunky tabulky (i `.t.areas`). */
    table: 8.8,
    /** `.t th` — zahlavi sloupce tabulky, i `.decide`/`.kpis`/`.tile` popisky sdileji hodnotu. */
    tableHead: 7.8,
    /** `.q p` — oduvodneni otazky mimo predlohu bytu. */
    questionBasis: 9,
    /** `.pill` — stitek verdiktu otazky. */
    pill: 9.4,
    /** `.pill.sm` — maly stitek v tabulce. */
    pillSmall: 7.6,
    /** `.src` — zdroj pod stitkem, i tabulka zdroju (`.t.src`). */
    source: 7.4,
    /** `.mean .mt` — nadpis bloku „Co to pro vas znamena". */
    meansLabel: 8,
    /** `.mean` — text bloku „Co to pro vas znamena". */
    meansText: 9.5,
    /** `.later` — text bloku „Doplnime". */
    pendingNote: 8.6,
    /** `.ty` — rok na casove ose. */
    timelineYear: 13,
    /** `.tl em` — poznamka na casove ose. */
    timelineNote: 7.8,
    /** `figcaption` — popisek obrazku. */
    caption: 7.7,
    /** `.hist figcaption` — popisek v pasu snimku. */
    imageStripCaption: 8.6,
    /** `.chart .ct` — titulek grafu. */
    chartTitle: 9.4,
    /** `.chart .cn` — poznamka pod grafem. */
    chartNote: 7.6,
    /** `.kpis b` — hodnota klicoveho ukazatele. */
    kpiValue: 15,
    /** `.kpis em` — poznamka pod klicovym ukazatelem. */
    kpiNote: 7.4,
    /** `.tiles.four .tile span` — popisek dlazdice ve ctyrsloupcove mrizce. */
    tileLabelFour: 7.4,
    /** `.tiles.four .tile p` — text dlazdice ve ctyrsloupcove mrizce. */
    tileNoteFour: 7.2,
    /** `.tile b` — hodnota dlazdice otisku. */
    tileValue: 11.5,
    /** `.tile p` — text dlazdice otisku. */
    tileNote: 7.8,
    /** `.road em` — poznamka v planu dalsich kroku. */
    roadNote: 8.2,
    /** `.contact` — kontaktni box na posledni strane. */
    contact: 10,
    /** `.checks li` v predloze bytu (mensim pismem nez zbytek dokumentu). */
    checksFlat: 8.8,
    /** `.t.areas/.notChecked/.requests/.evidence em` — druhy radek bunky (zdroj). */
    flatTableNote: 7.4,
    /** `.t.requests td` v predloze bytu. */
    flatRequests: 8.6,
    /** `.t.notChecked td` v predloze bytu. */
    flatNotChecked: 8,
    /** `.t.evidence td` v predloze bytu. */
    flatEvidence: 7.8,
    /** `.q h4` — nadpis otazky v podrobnem dokumentu bytu. */
    flatQuestionHeading: 9.6,
    /** `.q p` — oduvodneni otazky v podrobnem dokumentu bytu. */
    flatQuestionBasis: 8.3,
    /** `.ev` — stitek dukazu („D3") za oduvodnenim. */
    evidenceTag: 7,
};
/** Radkovani telocviku (`body{line-height:1.52}`), sdilene s `estimate.ts`. */
export const BODY_LINE_HEIGHT = 1.52;
/** Radkovani nadpisu kapitoly (`h2{line-height:1.18}`). */
export const H2_LINE_HEIGHT = 1.18;
/** Radkovani oduvodneni otazky v predloze bytu (`.q p{line-height:1.42}`). */
export const FLAT_QUESTION_LINE_HEIGHT = 1.42;
//# sourceMappingURL=type-scale.js.map